import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storageSession from 'redux-persist/lib/storage/session';
import authReducer from './auth';
import approvalReducers from './approval';
import cartReducers from './cart';
import catalogueReducers from './catalogue';
import checkoutReducers from './checkout';
import orderReducers from './order';
import contractReducers from './contract';
import accountReducers from './account';
import commonReducers from './common';
import reserveNumberReducer from './reservenumber';
import checkEligibilityReducers from './checkeligibility';
import changeMobileReducers from './changemobileno';
import numberShareReducers from './numberShare';
import transferLineReducers from './transferline';
import serRoadshowReducer from './serroadshow';
import promoConfigReducers from './promoConfigs';
import numberPort from './numberPort';
import simActivationReducer from './simactivation';
import eFormReducer from './eform';

const userPersistConfig = {
  key: 'auth',
  storage: storageSession
};

const appReducer = combineReducers({
  auth: persistReducer(userPersistConfig, authReducer),
  approval: approvalReducers,
  catalogue: catalogueReducers,
  cart: cartReducers,
  checkout: checkoutReducers,
  order: orderReducers,
  contract: contractReducers,
  account: accountReducers,
  common: commonReducers,
  reservenumber: reserveNumberReducer,
  checkEligibility: checkEligibilityReducers,
  numberShare: numberShareReducers,
  transferLine: transferLineReducers,
  changeNumber: changeMobileReducers,
  serRoadshow: serRoadshowReducer,
  promoConfigs: promoConfigReducers,
  numberPort: numberPort,
  simActivation: simActivationReducer,
  eform: eFormReducer
});

export default appReducer;
